import React from 'react'
import Webfont from 'webfontloader'
import { ThemeProvider } from 'styled-components'

import { createTheme } from 'shared/theme/index'

export default (props) => {
  const theme = createTheme(props.theme)

  const families = [
    `${props.theme.fonts.primary.family}:${props.theme.fonts.primary.variant}`
      .replace('regular', '400')
      .replace('italic', 'i')
  ]

  Webfont.load({
    google: {
      families
    }
  })

  return (
    <ThemeProvider theme={theme}>
      {props.children}
    </ThemeProvider>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/ThemeContext/index.js